import setCarePlan from './setCarePlan';

export default {
  setCarePlan,
};
